import { ShieldCheck, Zap, Sparkles, Clock, Award, Handshake } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "Profi-Sicherheitstechnik", desc: "Zertifizierte Premium-Funk-Sicherheitstechnik – Standard für professionelle Anwendungen im Immobilienbereich." },
  { icon: Zap, title: "Installation in < 1 Std.", desc: "Keine Kabelverlegung, keine Wanddurchbrüche. Aktiv am selben Tag." },
  { icon: Sparkles, title: "Spurlos rückbaubar", desc: "Kein Schaden, keine Bohrlöcher an sichtbaren Wänden – 100 % objektfreundlich." },
  { icon: Clock, title: "24/7 Überwachung", desc: "Rund um die Uhr Push-Benachrichtigungen und Statusupdates via App." },
  { icon: Award, title: "Premium-Argument", desc: "Sichtbares Sicherheitskonzept, das im Exposé und beim Besichtigungstermin überzeugt." },
  { icon: Handshake, title: "Partner-Konditionen", desc: "Für Makler und Bauträger – skalierbar für Portfolios und Projekte." },
];

export const TrustSection = () => {
  return (
    <section
      id="trust"
      data-testid="trust-advantages"
      className="ss-section relative overflow-hidden ss-navy-panel"
    >
      <div className="absolute inset-0 ss-grain pointer-events-none" aria-hidden="true" />
      <div className="absolute -bottom-24 left-0 h-80 w-80 rounded-full bg-[var(--ss-gold)]/8 blur-3xl" aria-hidden="true" />

      <div className="ss-container relative">
        <div className="max-w-3xl">
          <span className="ss-eyebrow-on-navy">Warum SecurityStaging.de</span>
          <h2 className="ss-h2 mt-4 text-white">Das Ergebnis: erfolgreicher Verkauf.</h2>
          <p className="ss-lead mt-4 text-slate-300">
            Schnellerer Verkauf durch Sicherheitsempfinden, ein hervorragendes Premium-Argument, reduziertes Makler-Risiko und Umsatzsteigerung durch attraktive Partner-Konditionen.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => (
            <div
              key={it.title}
              className="rounded-2xl bg-white/5 backdrop-blur border border-white/10 p-6 hover:border-[var(--ss-gold)]/40 hover:bg-white/[0.07] transition-all"
              data-testid={`trust-item-${i}`}
            >
              <div className="flex items-center gap-3">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--ss-gold)]/15 text-[var(--ss-gold)] border border-[var(--ss-gold)]/25">
                  <it.icon className="h-5 w-5" strokeWidth={2.2} />
                </span>
                <h3 className="font-display font-semibold text-white text-base">{it.title}</h3>
              </div>
              <p className="text-sm text-slate-300 mt-4 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>

        {/* KPI strip */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { kpi: "< 60 Min.", label: "Installation" },
            { kpi: "24 / 7", label: "Alarm-Überwachung" },
            { kpi: "0", label: "Wandschäden" },
            { kpi: "DE-weit", label: "Einsatzgebiet" },
          ].map((k) => (
            <div key={k.label} className="rounded-2xl border border-white/10 bg-black/20 p-5 text-center">
              <div className="font-display text-2xl sm:text-3xl font-bold text-[var(--ss-gold)]">{k.kpi}</div>
              <div className="text-xs text-slate-400 mt-1 uppercase tracking-widest">{k.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
